<template>
  <div class="login-content">
    <div v-click-outside="onClickOutside" class="modal-login">
      <div class="item--title">
        <span class="item--title">
          Select your country.
        </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon id="user--btn-icon" icon="times"
        /></span>
      </div>
      <div class="form-flags">
        <div>
          <figure @click="selectCountry('USA')" class="img-flag">
            <img src="/img/usa.png" alt="" />
          </figure>
        </div>
        <div>
          <figure @click="selectCountry('India')" class="img-flag">
            <img src="/img/ind.png" alt="" />
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "IthMenuAsside",
  data: () => ({
    login: false,
    directives: {
      clickOutside: vClickOutside.directive
    },
    form: { email: "" },
    alert: { color: "", message: "" }
  }),
  computed: mapState(["menuAsside"]),
  methods: {
    onClickOutside(event) {
      if (event.target.className == "login-content") {
        this.$store.commit("DISABLED_MENU");
      }
    },
    closeModal() {
      this.$store.commit("TOGGLE_MENU_LANGUAGE");
      this.$store.commit("DISABLED_MENU");
    },
    selectCountry(item) {
      this.$store.commit("TOGGLE_MENU_LANGUAGE");
      this.$store.commit("DISABLED_MENU");
      this.$store.dispatch("SET_COUNTRY", item);
    }
  }
};
</script>

<style scoped>
.login-content {
  background-color: rgba(44, 56, 72, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 15vh;
}
.modal-login {
  background-color: #284060;
  height: 400px;
  width: 30vw;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 120px 100px 180px;
  row-gap: 2%;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--title {
  text-align: center;
  padding-top: 30px;
}

.form-flags {
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 30%;
  justify-content: space-evenly;
}
.img-flag {
  margin: 0;
  width: 100%;
  cursor: pointer;
}
.img-flag > img {
  width: 100%;
}

@media (min-width: 1480px) {
  .modal-login {
    height: 50vh;
    width: 20vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-login {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-login {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-login {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-login {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
}
</style>
